

























import Vue from 'vue';
import JerseyButtonRed from '@/components/elements/JerseyButtonRed.vue';
import JerseyProgress from '@/components/elements/JerseyProgress.vue';

export default Vue.extend({
  name: 'QuestionLayout',
  props: {
    action: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    JerseyButtonRed,
    JerseyProgress,
  },
  methods: {
    onSubmit() {
      this.action();
    },
  },
  computed: {
    previousView(): string {
      return this.pageIndex <= 0 ? 'Start' : this.pages[this.pageIndex - 1];
    },
    nextView(): string {
      return this.pageIndex >= this.numPages - 1
        ? null
        : this.$store.state.pages[this.pageIndex + 1];
    },
    pages(): any[] {
      return this.$store.state.pages;
    },
    pageNum(): number {
      return this.pageIndex + 1;
    },
    numPages(): number {
      return this.$store.state.pages.length;
    },
    pageIndex(): number {
      return this.$store.getters.pageIndex;
    },
  },
});
